import Vue from 'vue';
import Router from 'vue-router';
import RootChrome from '@/components/layouts/RootChrome.vue';
import AppChrome from '@/components/layouts/AppChrome.vue';
import ClipCreator from '@/components/ClipCreator.vue';
import ClipBrowser from '@/components/ClipBrowser.vue';
import ClipReports from '@/components/ClipReports.vue';
import ChannelCreator from '@/components/ChannelCreator.vue';
import TimeShift from '@/components/TimeShift.vue';
import PageNotFound from '@/components/pages/error/PageNotFound.vue';
import guardAuth from '@/router/guard';

Vue.use(Router);

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      component: RootChrome,
      meta: { requiresAuth: true },
      children: [
        {
          path: ':teamName',
          name: 'AppChrome',
          component: AppChrome,
          redirect: ':teamName/capture',
          children: [
            {
              path: 'capture',
              name: 'ClipCreator',
              component: ClipCreator,
            },
            {
              path: 'clips',
              name: 'ClipBrowser',
              component: ClipBrowser,
            },
            {
              path: 'reports',
              name: 'ClipReports',
              component: ClipReports,
            },
            {
              path: 'timeshift',
              name: 'TimeShift',
              component: TimeShift,
              children: [
                {
                  path: ':scheduleYear/:scheduleMonth/:scheduleDay',
                  name: 'TimeShiftSchedule',
                  component: TimeShift,
                },
              ],
            },
            {
              path: 'channel/create',
              name: 'channelCreate',
              component: ChannelCreator,
            },
            {
              path: '*',
              component: PageNotFound,
            },
          ],
        },
      ],
    },
  ],
});

router.beforeEach(guardAuth);

export default router;
